export default __webpack_public_path__ + "static/media/resortleaders.56f28835.jpg";